module.exports = __webpack_public_path__ + "img/TDE_Grenade.6c7eaa6c.png";